/**
 * @desc sku保存草稿
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(body: defs.basics.PlmSkuEditRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/saveDraft`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
